(function (angular) {
  "use strict";

  angular.module("Toyota.Services").service("GlobalBreakpoints", [
    "$filter",
    function ($filter) {
      var exports = this;

      var breakpoints = ["xxxs", "xxs", "xs", "sm", "md", "lg"];

      exports.parseExpressionToArray = function (expression) {
        if (expression === "all") {
          return exports.all();
        }

        if (expression.match(/^.*-$/)) {
          return exports.prevAllAndSelf(expression.match(/^(.*)-$/)[1]);
        }

        if (expression.match(/^.*\+$/)) {
          return exports.nextAllAndSelf(expression.match(/^(.*)\+$/)[1]);
        }

        return [expression];
      };

      exports.parseCompoundExpression = function (compoundExpression) {
        if (!compoundExpression) {
          return null;
        }

        return $filter("arrayUnique")(
          compoundExpression
            .split(" ")
            .map(function (expression) {
              return exports.parseExpressionToArray(expression);
            })
            .reduce(function (a, b) {
              return a.concat(b);
            }, [])
            .sort(function (a, b) {
              return breakpoints.indexOf(a) - breakpoints.indexOf(b);
            })
        );
      };

      exports.prev = function (breakpoint) {
        var index = breakpoints.indexOf(breakpoint);

        if (index === -1 || index === 0) {
          return null;
        }

        return breakpoints[index - 1];
      };

      exports.next = function (breakpoint) {
        var index = breakpoints.indexOf(breakpoint);

        if (index === -1 || index === breakpoints.length - 1) {
          return null;
        }

        return breakpoints[index + 1];
      };

      exports.prevAllAndSelf = function (breakpoint) {
        var index = breakpoints.indexOf(breakpoint);

        if (index === -1) {
          return [];
        }

        return breakpoints.slice(0, index + 1);
      };

      exports.nextAllAndSelf = function (breakpoint) {
        var index = breakpoints.indexOf(breakpoint);

        if (index === -1) {
          return [];
        }

        return breakpoints.slice(index);
      };

      exports.all = function () {
        return breakpoints.slice(0);
      };

      return exports;
    },
  ]);
})(window.angular);
